/** A review page lives in the space it was opened from: the admin keeps the admin shell and its sidebar, a member the chat space. */
export const reviewPagePath = (route: string, admin: boolean) => (admin ? `/admin${route}` : route);

/** Back to the Requests page a review page was opened from: its Request templates tab. */
export const requestsPath = (admin: boolean) => `${admin ? "/admin" : ""}/approvals?tab=templates`;
